import React from "react";
import VendedorCarteiraHeader from "./VendedorCarteiraHeader";

const VendedorCarteira = ({
  carteira,
  imagens,
  handleImageUpload,
  setImagem,
  save,
  handleInputChange,
  toggleSave,
  handleSave,
  onTagChange,
}) => {
  return (
    <div
      className={`flex flex-col m-1 bg-[#aac5fc] shadow-lg rounded-2xl transition-height duration-300`}
      key={carteira.id}
    >
      <div className="flex">
        <VendedorCarteiraHeader
          carteira={carteira}
          imagens={imagens}
          handleImageUpload={handleImageUpload}
          setImagem={setImagem}
          save={save}
          handleInputChange={handleInputChange}
          toggleSave={toggleSave}
          handleSave={handleSave}
          onTagChange={onTagChange} 
        />
      </div>
    </div>
  );
};

export default VendedorCarteira;
